// frontend/src/utils/formatters.js

/**
 * Calcula la edad a partir de una fecha de nacimiento y una fecha de referencia.
 * Si no se indica fecha de referencia, usa la fecha actual.
 *
 * @param {string|Date} birthdate - Fecha de nacimiento.
 * @param {string|Date} [referenceDate=new Date()] - Fecha base para el cálculo.
 * @returns {number|null} - Edad o null si fecha inválida.
 */
export function calculateAge(birthdate, referenceDate = new Date()) {
  const birth = new Date(birthdate)
  const ref = new Date(referenceDate)

  if (isNaN(birth)) return null

  let age = ref.getFullYear() - birth.getFullYear()
  const monthDiff = ref.getMonth() - birth.getMonth()
  const dayDiff = ref.getDate() - birth.getDate()

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--
  }

  return age
}

/**
 * Convierte una cadena en formato Título (Title Case),
 * manteniendo en minúscula las conjunciones o preposiciones comunes.
 *
 * @param {string} str - Cadena a convertir.
 * @returns {string} - Cadena en formato Título.
 */
export function toTitleCase(str) {
  if (!str) return ''

  const exceptions = ['de', 'del', 'la', 'los', 'las', 'y', 'o']

  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      if (index > 0 && exceptions.includes(word)) {
        return word
      }
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
} 
